import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Console from "./pages/Console";
import Settings from "./pages/Settings";
import Analytics from "./pages/Analytics";
import PrivateRoute from "./components/PrivateRoute";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/Verify";
import RequireToken from "./components/RequireToken";
import { UserEventProvider } from "./contexts/UserEvent";
import CookieConsent from "react-cookie-consent";
import SubscriptionPlans from "./pages/SubscriptionPlans";
import ManageSubscription from "./pages/ManageSubscription";
import Footer from "./components/Footer";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Whatsapp from "./pages/Whatsapp";
import About from "./pages/About";
import RefreshTracking from "./pages/Refresh";
import DisableTracking from "./pages/Disable";

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <UserEventProvider>
        <div style={{ minHeight: "100vh" }}>
          <CookieConsent buttonText="Got it!">
            This website uses cookies to enhance user experience.
          </CookieConsent>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/verify"
              element={
                <RequireToken>
                  <VerifyEmail />
                </RequireToken>
              }
            />
            <Route
              path="/reset-password"
              element={
                <RequireToken>
                  <ResetPassword />
                </RequireToken>
              }
            />
            <Route
              path="/console"
              element={
                <PrivateRoute>
                  <Console />
                </PrivateRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <PrivateRoute>
                  <Analytics />
                </PrivateRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <Settings />
                </PrivateRoute>
              }
            />
            <Route path="/whatsapp" element={<Whatsapp />} />
            <Route
              path="/manage"
              element={
                <PrivateRoute>
                  <ManageSubscription />
                </PrivateRoute>
              }
            />
            <Route path="/plans" element={<SubscriptionPlans />} />
            <Route path="/refresh" element={<RefreshTracking />} />
            <Route path="/disable" element={<DisableTracking />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <div style={{ marginTop: "auto", background: "#3c3747" }}>
            <Footer />
          </div>
        </div>
      </UserEventProvider>
    </HelmetProvider>
  );
};

export default App;
